import React from "react";
import { Input } from "semantic-ui-react";

import styles from "./Input.less";

// We could remove the <input id={id} />,
// if https://github.com/Semantic-Org/Semantic-UI-React/issues/980 gets done and merged
export default function InputControl({
  type = "text",
  name,
  onFocus,
  onBlur,
  onChange,
  onKeyPress,
  onKeyDown,
  onKeyUp,
  value,
  id,
  inputRef,
  inputLabel,
  inputLabelPosition = "right",
  inputClassName,
  ...rest
}) {
  inputLabel = typeof inputLabel === "string" ? <span className={styles["inputLabel"]}>{inputLabel}</span> : inputLabel;
  const handleChange =
    onChange &&
    ((event, data) => {
      onChange(type === "number" ? (data.value === "" ? null : +data.value) : data.value, event, data);
    });

  if (__DEV__ && value === undefined && type !== "file") {
    throw new Error(`value is undefined: InputControl(${JSON.stringify(arguments[0])})`);
  }

  return (
    <Input type={type} name={name} value={value === null ? "" : value} onChange={handleChange} {...rest}>
      {inputLabelPosition === "left" && inputLabel}
      <input
        id={id}
        ref={inputRef}
        className={inputClassName}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
      />
      {inputLabelPosition === "right" && inputLabel}
    </Input>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/Input.jsx